import { Switch, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useAIAssistantSelector, useAIAssistantActions } from '@domains/aiAssistant';

export function AutoExecuteToggle() {
  const autoExecute = useAIAssistantSelector( s => s.autoExecute );
  const { toggleAutoExecute } = useAIAssistantActions();
  const { t } = useTranslation( 'interactions' );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Switch
        size="xs"
        label={t( 'ai_assistant_auto_execute' )}
        checked={autoExecute}
        onChange={toggleAutoExecute}
        styles={{
          label: { fontSize: 11, cursor: 'pointer', paddingLeft: 4 },
          track: { cursor: 'pointer' }
        }}
      />
      <Text size="xs" c="dimmed" style={{ fontSize: 10 }}>
        {t( 'ai_assistant_auto_execute_description' )}
      </Text>
    </div>
  );
}
